const words: Record<string, string> = {
  UNASSIGNED: '待分配', IN_PROGRESS: '标注中', SUBMITTED: '待审核', APPROVED: '已通过', CHANGES_REQUESTED: '需修改',
  owner: '项目负责人', annotator: '标注员', reviewer: '审核员', viewer: '查看员',
  seeded: '带标签修正', blank: '空白标注',
  create: '创建', assign: '分配', checkout: '开始编辑', save: '保存', submit: '提交审核',
  review: '审核', approve: '通过', 'request-changes': '退回修改', reopen: '重新开放', import: '导入',
  Axial: '横断面', Coronal: '冠状面', Sagittal: '矢状面', Volume: '三维',
  Oblique: '斜切面', 'Oblique Slice': '斜切面', Cine: '序列播放',
};
export const zh = (value?: string | null) => value ? words[value] ?? value : '';

const errors: Record<string, string> = {
  'Failed to fetch': '网络连接失败，请检查连接后重试。',
  'Load a task first.': '请先打开任务。',
  'Reopen the task to acquire an editor lease.': '请重新开放任务后开始编辑。',
  'An instance name is required.': '请填写标签名称。',
  'Select a committed revision.': '请选择已保存的版本。',
  'Select a target label before filling.': '使用油漆桶前，请先选择目标标签。',
  'Index lies outside the source volume.': '该坐标超出影像范围。',
  'Choose an unused integer label value between 1 and 65535.': '请选择 1–65535 之间尚未使用的整数标签编号。',
  'Label data contains unsupported values; import was refused.': '标签包含不支持的编号，已停止导入。',
  'Choose an unused uint16 label value and a name.': '请填写尚未使用的标签编号和名称。',
  'Declare the native mesh units explicitly as mm.': '请确认网格原生单位为毫米。',
  'This mesh workspace accepts PLY and STL.': '网格工作区支持 PLY 和 STL 文件。',
  'A nonempty polygon mesh is required.': '请选择含有多边形的有效网格。',
  'Reader indices differ from the canonical asset counts. Import was refused.': '网格顶点或面数量与原始数据不一致，已停止导入。',
  'Mesh coordinates must be finite.': '网格坐标必须是有效数值。',
  'Open the canonical mesh before its labels.': '请先打开原始网格，再导入标签。',
  'Choose a positive uint16 label value.': '请选择 1–65535 之间的标签编号。',
  'Create an instance before painting.': '绘制前，请先创建标签。',
  'Unlock the selected instance before editing.': '请先解锁所选标签再编辑。',
  'Normal angle must be in 0..180 degrees.': '法线夹角必须在 0–180 度之间。',
  'Stroke exceeds the 200,000 vertex limit. Reduce the brush radius.': '该笔超过 20 万顶点上限，请减小画笔半径。',
  'Unlock affected instances before undo/redo.': '请先解锁受影响的标签，再撤销或重做。',
  'Decoded dimensions differ from the registered source grid.': '解码后的影像尺寸与登记的源影像不一致。',
  'Decoded affine differs from registered LPS millimetres; no resampling was applied.': '影像空间坐标与登记信息不一致，已停止加载，未进行重采样。',
  'Image decoding did not finish within 90 seconds.': '影像解析超时，请刷新后重试。',
  'Translation must be finite mm.': '平移量必须是有效的毫米数值。',
  'Load the source mesh.': '请先加载源网格。',
  'Use a hex color, e.g. #7798C4.': '请输入颜色代码，例如 #7798C4。',
};
export function errorText(error: unknown) {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return errors[message] ?? (/\p{Script=Han}/u.test(message) ? message : '操作未完成，请检查输入或刷新页面后重试。');
}
export function apiErrorText(message: string, status: number) {
  if (errors[message] || /\p{Script=Han}/u.test(message)) return errorText(message);
  return ({ 400: '请求内容有误，请检查输入。', 401: '用户名或密码错误，或登录已失效。',
    403: '没有权限执行此操作，请联系项目负责人。', 404: '所需任务或文件不存在。',
    409: '任务状态已变化或正在其他窗口编辑，请刷新后重试。',
    422: '输入内容未通过校验，请检查文件、标签或必填信息。',
  } as Record<number, string>)[status] ?? `服务请求失败（${status}），请稍后重试。`;
}
